import { Typography } from '@mui/material';
import CasLabel from '../CasLabel/CasLabel';
import CasLink from '../CasLink/CasLink';

interface ICasDisplayField {
  label: string | React.ReactElement;
  value: React.ReactNode;
  className?: string;
  horizontal?: boolean;
  fullWidth?: boolean;
  onClick?: VoidFunction | null;
}

// An empty value keeps one line of height, so the next field's label doesn't read as its value.
const valueSx = { minHeight: '1lh' };

export default function CasDisplayField({
  label,
  value,
  className,
  horizontal = false,
  fullWidth,
  onClick = null,
}: ICasDisplayField) {
  const renderLabel = onClick ? <CasLink onClick={onClick}>{label}</CasLink> : label;

  const renderValue = () => {
    if (Array.isArray(value)) {
      return value.map((v, index) => (
        <Typography
          key={index}
          variant="body2"
          component="div"
          className="cas-display-value"
          sx={valueSx}
        >
          {v}
        </Typography>
      ));
    }

    return (
      <Typography variant="body2" component="div" className="cas-display-value" sx={valueSx}>
        {value ?? ''}
      </Typography>
    );
  };

  return (
    <CasLabel
      label={renderLabel}
      className={`cas-display-field ${  horizontal ? 'cas-horizontal-field ' : ''}${className}`}
      sx={fullWidth && { flex: 1 }}
    >
      {renderValue()}
    </CasLabel>
  );
}
